import React, { ChangeEvent } from "react";
import classNames from "classnames";
import { Field, Formik } from "formik";
import styles from "./SidebarFeedbackModal.module.css";

type SidebarFeedbackMessageFieldProps = {
  label: string;
  placeholder: string;
  value: string;
  maxLength: number;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  maxLimitMessage: string;
  showRequiredError: boolean;
  requiredErrorText: string;
};

export default function SidebarFeedbackMessageField({
  label,
  placeholder,
  value,
  maxLength,
  onChange,
  maxLimitMessage,
  showRequiredError,
  requiredErrorText,
}: SidebarFeedbackMessageFieldProps) {
  const isAtMaxLength = value.length >= maxLength;
  const isEmpty = value.trim().length === 0;
  const shouldShowRequired = showRequiredError && isEmpty;
  const shouldShowMax = !shouldShowRequired && isAtMaxLength;
  const errorText = shouldShowRequired ? requiredErrorText : shouldShowMax ? maxLimitMessage : "";

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.textareaHeader}>
        <label className={styles.fieldLabel}>
          {label}
          <span className={styles.requiredMark}>*</span>
        </label>
        <span
          className={classNames(styles.counter, {
            [styles.counterError]: isAtMaxLength,
          })}
        >
          {value.length}/{maxLength}
        </span>
      </div>
      <Formik initialValues={{ message: value }} enableReinitialize onSubmit={() => {}}>
        {() => (
          <Field
            as="textarea"
            id="message"
            name="message"
            className={classNames(styles.textarea, {
              [styles.textareaError]: isAtMaxLength || shouldShowRequired,
            })}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        )}
      </Formik>
      {errorText && <p className={styles.errorText}>{errorText}</p>}
    </div>
  );
}
